import * as THREE from 'three'
import Line2 from '@glass-designer/library/three/Line2'
import LineGeometry from '@glass-designer/library/three/LineGeometry'
import LineMaterial from '@glass-designer/library/three/LineMaterial'


/**
 * LineObject
 * Object to display a line with a path
 * Used to display selections / highlights
 */
export default class LineObject {
  constructor(options = {}) {

    this.colour = options.colour || '#FF0000'
    this.width = parseFloat(options.width || 2)
    this.opacity = parseFloat(options.opacity === undefined ? 1.0 : options.opacity)
    this.transparent = !!options.transparent
    this.userData = options.userData || {}

    this.pathPoints = []

    this.lineGeometry = null
    this.lineObj = null    
    this.lineMaterial = null
  }


  /**
   * Dispose the object
   */
  dispose() {
    if(this.lineGeometry) {
      this.lineGeometry.dispose()
      this.lineGeometry = null
    }
    this.lineObj = null
    this.lineMaterial = null
  }


  /**
   * Update the resolution on the line object
   */
  updateResolution(viewportWidth, viewportHeight) {
    if(this.lineMaterial)
      this.lineMaterial.resolution.set(viewportWidth, viewportHeight)
  }


  /**
   * Set the visibility of the object
   */
  setVisible(visible) {
    if(this.lineObj)
      this.lineObj.visible = visible
  }


  /**
   * Update the line positions
   * Positions is an array of Vector2/Vector3 objects
   */
  updateLinePath(positionList) {
    this.pathPoints = positionList

    this.updateSceneObject()
  }


  /**
   * Update the scene object
   */
  updateSceneObject() {
    if(this.pathPoints.length == 0)
      return

    var geomPositions = []
    this.pathPoints.forEach(point => {
      geomPositions.push(point.x, point.y, point.z || 99)
    })

    if(!this.lineGeometry) {
      this.lineGeometry = new LineGeometry();
      this.lineGeometry.setPositions(geomPositions)
    } else {
      this.lineObj.geometry.setPositions(geomPositions)
      this.lineObj.computeLineDistances()
    }

    if(!this.lineMaterial) {
      this.lineMaterial = new LineMaterial({
        color: this.colour,
        linewidth: this.width,
        opacity: this.opacity,
        transparent: this.transparent,
        vertexColors: false,
        resolution: new THREE.Vector2(0, 0),
        dashed: false,
        alphaToCoverage: true
      })
    }

    if(!this.lineObj) {
      this.lineObj = new Line2(this.lineGeometry, this.lineMaterial)
      this.lineObj.computeLineDistances()
      this.lineObj.scale.set(1, 1, 1)
    }
  }


  /**
   * Get the Three.js object
   */
  getThreeObject() {
    return this.lineObj
  }


}
